import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import * as _ from 'lodash';

import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { Question, QuestionOption } from '../../../../_models';
import { QuestionType } from '../../../../_enums';

@Component({
  selector: 'app-question-type-checkbox',
  templateUrl: './question-type-checkbox.component.html',
  styleUrls: ['./question-type-checkbox.component.scss']
})
export class QuestionTypeCheckboxComponent implements OnInit {
  @Input('question') question: Question;
  @Input('formGroup') formGroup: FormGroup;
  @Input('viewOnly') viewOnly = false;
  settings: Settings;

  constructor(
    private fb: FormBuilder,
    public appSettings: AppSettings,
  ) {
    this.settings = this.appSettings.settings;
  }


  get options(): FormArray {
    if (!this.formGroup)
      return null;
    return this.formGroup.get('options') as FormArray;
  }
  ngOnInit() {
    this.formGroup.reset();
    this.formGroup.addControl('options', this.fb.array([]));
    this.options.controls.length = 0;

    this.formGroup.setValidators(this.getCorrectAnswerValidator());

    if (!this.question || this.question.questionType !== QuestionType.Checkbox ||
      !this.question.options || this.question.options.length === 0) {
      this.options.push(this.createOptionFormItem(null));
      this.options.push(this.createOptionFormItem(null));
      this.options.controls[0].get('isCorrect').setValue(true);
    } else {
      _.forEach(this.question.options, o => this.options.push(this.createOptionFormItem(o)));
    }

    if (this.viewOnly)
      this.formGroup.disable();
  }
  createOptionFormItem(option: QuestionOption): FormGroup {
    return this.fb.group({
      id: option ? option.questionOptionId : 0,
      title: [option ? option.title : '', [Validators.required]],
      isCorrect: option ? option.isCorrect : false,
    });
  }


  getCorrectAnswerValidator(): ValidatorFn {
    const me = this;
    return (control: AbstractControl): ValidationErrors | null => {
      const answer = me.options.controls.filter(x => x.get('isCorrect').value === true);
      if (answer.length === 0) {
        return { 'noCorrectAnswer': true };
      }
      return null;
    };
  }
}
